import { render, staticRenderFns } from "./setting-toggle.vue?vue&type=template&id=787126f2&"
import script from "./setting-toggle.vue?vue&type=script&lang=js&"
export * from "./setting-toggle.vue?vue&type=script&lang=js&"
import style0 from "./setting-toggle.vue?vue&type=style&index=0&id=787126f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports